export default __webpack_public_path__ + "locales/si/SendInviteDialog.json?hash=9085b15179d40da0d04ca657a35e3aa8";